export type TwilioVoiceGender = "female" | "male";

export const SPANISH_LANGUAGE_GROUP = "es";
export const ENGLISH_LANGUAGE_GROUP = "en-US";

export interface TwilioVoiceCatalogEntry {
  voice: string;
  language: string;
  languageLabel: string;
  label: string;
  gender: TwilioVoiceGender;
  previewText: string;
  previewUrl: string;
}

export const DEFAULT_TTS = {
  language: "en-US",
  voice: "Polly.Joanna",
} as const;

const PREVIEW_TEXT_EN =
  "Hello! This is a preview of the voice for your virtual receptionist. Thank you for calling.";
const PREVIEW_TEXT_ES =
  "¡Hola! Esta es una muestra de la voz de tu recepcionista virtual. Gracias por llamar.";

export const VOICE_PREVIEW_BASE_URL =
  "https://flownect-flow-mobile-dev.s3.us-west-1.amazonaws.com/tts-preview";

const previewUrlFor = (voice: string): string =>
  `${VOICE_PREVIEW_BASE_URL}/${voice.replace(/^Polly\./, "").toLowerCase()}.mp3`;

export const TWILIO_VOICE_CATALOG: TwilioVoiceCatalogEntry[] = [
  {
    voice: "Polly.Joanna",
    language: "en-US",
    languageLabel: "English (US)",
    label: "Joanna",
    gender: "female",
    previewText: PREVIEW_TEXT_EN,
    previewUrl: previewUrlFor("Polly.Joanna"),
  },
  {
    voice: "Polly.Matthew",
    language: "en-US",
    languageLabel: "English (US)",
    label: "Matthew",
    gender: "male",
    previewText: PREVIEW_TEXT_EN,
    previewUrl: previewUrlFor("Polly.Matthew"),
  },
  {
    voice: "Polly.Salli",
    language: "en-US",
    languageLabel: "English (US)",
    label: "Salli",
    gender: "female",
    previewText: PREVIEW_TEXT_EN,
    previewUrl: previewUrlFor("Polly.Salli"),
  },
  {
    voice: "Polly.Joey",
    language: "en-US",
    languageLabel: "English (US)",
    label: "Joey",
    gender: "male",
    previewText: PREVIEW_TEXT_EN,
    previewUrl: previewUrlFor("Polly.Joey"),
  },
  {
    voice: "Polly.Lupe",
    language: "es-US",
    languageLabel: "Español",
    label: "Lupe",
    gender: "female",
    previewText: PREVIEW_TEXT_ES,
    previewUrl: previewUrlFor("Polly.Lupe"),
  },
  {
    voice: "Polly.Mia",
    language: "es-MX",
    languageLabel: "Español",
    label: "Mia",
    gender: "female",
    previewText: PREVIEW_TEXT_ES,
    previewUrl: previewUrlFor("Polly.Mia"),
  },
];

export function isSpanishLanguage(language: string): boolean {
  return language === "es-US" || language === "es-MX";
}

export function getLanguageGroup(language: string): string {
  return isSpanishLanguage(language) ? SPANISH_LANGUAGE_GROUP : ENGLISH_LANGUAGE_GROUP;
}

export function getLanguageOptions() {
  return [
    { language: ENGLISH_LANGUAGE_GROUP, languageLabel: "English (US)" },
    { language: SPANISH_LANGUAGE_GROUP, languageLabel: "Español" },
  ];
}

export function getVoicesByLanguage(languageOrGroup: string) {
  if (languageOrGroup === SPANISH_LANGUAGE_GROUP) {
    return TWILIO_VOICE_CATALOG.filter((entry) => isSpanishLanguage(entry.language));
  }

  return TWILIO_VOICE_CATALOG.filter((entry) => entry.language === languageOrGroup);
}

export function findVoiceCatalogEntry(voice: string, language?: string) {
  return TWILIO_VOICE_CATALOG.find(
    (entry) => entry.voice === voice && (language === undefined || entry.language === language)
  );
}
